import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PayContext from '@/product/context/payment/payContext'
import AuthContext from '../../product/context/auth/authContext'
import Lottie from 'react-lottie'
import animationData from '../../assets/lottie/paymentAnimation.json'
import successAnimation from '../../assets/lottie/successAnimation.json'
import failureAnimation from '../../assets/lottie/failureAnimation.json'
import queryString from 'query-string'
import { handleRedirectInternal } from '../../product/common/components'
import CustomDialog from '../../custom/components/organisms/Dialog'
import { Button } from '@material-ui/core'
import { currencyFormat } from '../../custom/common/components'
import PayGccContext from '../../product/context/payment/paygcc/payGccContext'
import BuyerContext from '../../product/context/buyer/buyerContext'
import AlertContext from '@/product/context/alert/alertContext'
import JustContext from '@/product/context/payment/justgiving/justContext'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import './Checkout.css'

const SuccessPay = (props) => {
    const justContext = useContext(JustContext)
    const buyerContext = useContext(BuyerContext)
    const payContext = useContext(PayContext)
    const authContext = useContext(AuthContext)
    let { bidConfirm } = buyerContext
    const alertContext = useContext(AlertContext)
    const invoiceContext = useContext(InvoiceContext)
    const { getAllUserInvoices } = invoiceContext
    const { setAlert } = alertContext

    const [paymentResponse, setPaymentResponse] = useState(null)
    const { responseStatus: responseStatusJust, payResponse } = justContext
    const [rosoomResponse, setRosoomResponse] = useState(null)
    const [toggleDialogDeposit, setToggleDialogDeposit] = useState(false)

    const changeDialogStatusDeposit = () => {
        setToggleDialogDeposit(!toggleDialogDeposit)
    }

    const { isAuthenticated, loadUser } = authContext
    const history = useHistory()
    const {
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = payContext

    useEffect(() => {
        if (props.location.search) {
            const response = queryString.parse(props.location.search)
            setPaymentResponse(null)
            console.log(response, 'what response')

            payResponse({
                jgDonationId: response.jgDonationId,
                donationId: response.donationId,
            })
            // setToggleDialogDeposit(true)
            // responseCartPayTm({ response })
            history.replace({
                search: '',
            })
        }
    }, [props.location.search])

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    localStorage.removeItem('paydata')
                    if (responseStatusPayment.type === 6) {
                        window.location.replace(responseStatusPayment.data)
                    }
                }
            }
            clearResponsePayment()
            // if (responseStatusPayment.from === 'paytmResponse') {
            //     setPaymentResponse(responseStatusPayment)
            //     clearResponsePayment()
            //     setToggleDialogDeposit(true)
            //     loadUser()
            // }
        }
    }, [responseStatusPayment])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentSuccessOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: successAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const paymentFailureOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: failureAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const redirectFunction = () => {
        if (responseStatusJust.from === 'justgiving_response') {
            if (responseStatusJust.status === 'success') {
                handleRedirectInternal(history, 'invoices/all')
            } else {
                history.goBack()
            }
        }
    }

    useEffect(() => {
        if (responseStatusJust && responseStatusJust.from === 'justgiving_response') {
            if (responseStatusJust.status === 'success') {
                let formData = localStorage.getItem('paydata')
                formData = JSON.parse(formData)
                console.log(formData, 'formDatat')
                getAllUserInvoices(
                    {
                        limit: 10,
                        page: 1,
                        checkout: 1,
                        // admin: 1,
                        action: 'allunpaid',
                        filters: {
                            active: {
                                value: '2',
                                type: 'notin',
                                field: 'b.active',
                            },
                            action: {
                                value: '',
                                type: 'in',
                                field: 'b.paid',
                            },
                        },
                    },
                    'userUnpaidInvoice',
                )
                if (formData) {
                    if (formData.cart_id && !formData.invoice_id) {
                        setToggleDialogDeposit(true)
                        // handleRedirectInternal(history, 'invoices/all')
                    } else {
                        formData['invoice_id'] = responseStatusJust.data.common_invoice
                        formData.payment_object['invoice_id'] =
                            responseStatusJust.data.common_invoice
                        payCartStripe(formData)
                        localStorage.removeItem('paydata')
                    }
                } else {
                    setToggleDialogDeposit(true)
                }
            } else {
                console.log('eeeeeeeeeeeee', responseStatusJust)
                setAlert('Payment is processing', 'error')
                handleRedirectInternal(history, 'invoices/all')
            }
        }
    }, [responseStatusJust])
    return (
        <div className="container">
            <div className="paymentResponse lottie-container">
                <Lottie options={defaultOptions} speed="0.25" height={300} width={400} />
                <h2>{'Hang in there your payment is being processed'}</h2>
                <h4>{'Please do not press the back button or refresh the page'}</h4>
            </div>
            {responseStatusJust && responseStatusJust.status ? (
                <CustomDialog
                    title=""
                    disableBackdropClick
                    open={toggleDialogDeposit}
                    className="paymentNotifCnt"
                    function={changeDialogStatusDeposit}
                >
                    {responseStatusJust.status === 'success' ? (
                        <div className="paymentNotif">
                            <Lottie
                                options={paymentSuccessOptions}
                                speed="0.25"
                                height="auto"
                                width={150}
                            />
                            <div>
                                <h3>Payment Done</h3>

                                {/* <h5>
                                    You have successfully made a purchase of{' '}
                                    {currencyFormat(rosoomResponse.serviceCost)}.
                                </h5> */}
                                <Button onClick={() => redirectFunction()}>OK</Button>
                            </div>
                        </div>
                    ) : (
                        <div className="paymentNotif failure">
                            <Lottie
                                options={paymentFailureOptions}
                                speed="0.25"
                                height="auto"
                                width={150}
                            />
                            <div>
                                <h3>Payment Failed</h3>
                                <h5>
                                    {responseStatusJust.message ? responseStatusJust.message : ''}
                                </h5>
                                <Button onClick={() => redirectFunction()}>OK</Button>
                            </div>
                        </div>
                    )}
                </CustomDialog>
            ) : null}
        </div>
    )
}

export default SuccessPay
